export default __webpack_public_path__ + "static/media/new-logo.5086cdaf.png";